<template>
	<div
		@click="
			(e) => {
				if (shouldCompleteSetup && !isPaused) {
					$emit('open-setup');
				}
				e.preventDefault();
			}
		"
		:class="{
			disabled: !isPublished || isPaused || !hasToggleActivePermissions,
			pending: shouldCompleteSetup && !isPaused,
			active: isPublished && !shouldCompleteSetup && !isPaused,
		}"
		class="active-status user-select-none flex-centerize"
		:style="`width: ${width}; height: ${height}`"
	>
		{{ status }}

		<AppDropdownMenu
			left
			bottom
			absolute
			min-width="200"
			nudge-bottom="8"
			content-class="men"
			:items="enabledMenuItems"
			v-if="((isPublished && !shouldCompleteSetup) || isPaused) && hasToggleActivePermissions"
		>
			<template #activator="{ value }">
				<div
					@click="(e) => e.preventDefault()"
					:class="{ show: value }"
					class="activator flex-centerize flex-row"
					v-if="(isPublished && !shouldCompleteSetup) || isPaused || value"
				>
					<div class="divider ml-3 mr-1" />
					<v-icon size="20px" class="chevron">mdi-chevron-{{ value ? 'up' : 'down' }}</v-icon>
				</div>
			</template>
		</AppDropdownMenu>
	</div>
</template>
<script>
import { updateWorkflowIsActive } from '@/store/modules/workflows/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';
export default {
	name: 'ModuleActivenessStatus',
	props: {
		width: { type: String, default: '104px' },
		height: { type: String, default: '25px' },
		flowData: { type: Object },
		hasToggleActivePermissions: { type: Boolean },
	},
	computed: {
		status() {
			if (this.isPaused) {
				return 'Disabled';
			} else if (this.shouldCompleteSetup) {
				return 'Complete setup';
			} else if (this.isPublished) {
				return 'Active';
			} else {
				return 'Draft';
			}
		},
		isPublished() {
			return this.flowData.is_published;
		},
		isPaused() {
			return !this.flowData.is_active && this.isPublished;
		},
		shouldCompleteSetup() {
			return this.flowNeedsSetup && !this.flowData.is_setup_completed;
		},
		userSetupId() {
			return this.flowData.current_version_user_setup;
		},
		generalSetupId() {
			return this.flowData.current_version_general_setup;
		},
		hasUserSetup() {
			return !!this.userSetupId;
		},
		hasGeneralSetup() {
			return !!this.generalSetupId;
		},
		flowNeedsSetup() {
			return this.hasUserSetup || this.hasGeneralSetup;
		},
		enabledMenuItems() {
			return [
				{
					text: this.activeText,
					onClick: this.toggleActivation,
					disabled: !this.hasToggleActivePermissions || !this.flowData.is_published,
				},
			];
		},
		activeText() {
			return this.flowData.is_active ? 'Disable' : 'Enable';
		},
	},
	methods: {
		...mapActionsShorthand({ updateWorkflowIsActive }),
		async toggleActivation() {
			await this.updateWorkflowIsActive({ id: this.flowData.id, isActive: !this.flowData.is_active });
		},
	},
};
</script>
<style scoped lang="scss">
.active-status {
	font-size: 12px;
	line-height: 10px;
	border-radius: 6px;
	text-align: center;
	font-weight: normal;
	color: var(--bg-color);

	&.disabled {
		color: #a5a5a5;
		background: #f1f1f1;
	}
	&.active {
		color: #21bc9d;
		background: #d1f2eb;
	}
	&.pending {
		cursor: pointer;
		color: #615df4;
		background: #615df430;
	}

	&:hover {
		filter: brightness(95%);
		transition: 0.3s;

		.activator {
			max-width: 100%;
			transition: 0.2s;
		}
	}
}
.activator {
	display: flex;
	overflow: hidden;
	max-width: 0;
	transition: 0.2s;
	&.show {
		max-width: 100%;
		transition: 0.2s;
	}
}

.divider {
	width: 0px;
	height: 16px;
	border: 1px solid #ffffff;
}
</style>
